export default {
  appName: "云兔智能系统",
  appLogo: `${import.meta.env.BASE_URL}default-logo.png`,
  subApps: [
    {
      name: "ice-micro-app",
      activePath: "",
      // basename: '',
      title: "ice-micro-app 微应用示例页面",
      url: ["https://unpkg.com/icestark-child-common@0.1.1/build/js/index.js"],
    },
    {
      name: "vite-micro-app",
      activePath: "/path23-uuid",
      // basename: '',
      title: "vite 打包的 ES Module 类型微应用示例",
      loadScriptMode: "import",
      url: [
        "https://vite.dev.lovrabet.com:4173/assets/main.css",
        "https://vite.dev.lovrabet.com:4173/assets/main.js",
      ],
    },
    // {
    //   name: 'gateway',
    //   activePath: '/app/gateway',
    //   // basename: '',
    //   title: '网关应用研发',
    //   url: [
    //     'https://g.alicdn.com/cone-group/conex-gateway/0.0.2/css/app.css',
    //     'https://g.alicdn.com/cone-group/conex-gateway/0.0.2/js/app.js',
    //   ],
    // },
    // {
    //   name: 'site',
    //   activePath: '/app/site',
    //   // basename: '',
    //   title: '网关应用研发',
    //   url: [
    //     'https://g.alicdn.com/cone-group/conex-site/0.0.1/css/app.css',
    //     'https://g.alicdn.com/cone-group/conex-site/0.0.1/js/app.js',
    //   ],
    // },
  ],
};
